import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import _ from 'lodash'

import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'

import { Header, HeaderShim } from '../../fuselage/global/header/header'
import { SpeakerGrid } from "../../fuselage/layout/speaker-grid/speaker-grid"
import { Sidebar } from '../../fuselage/layout/sidebar/sidebar'
import HubspotForm from'../../fuselage/components/hubspot-form/hubspot-form'

import CSS from '../../css/app/speakers.module.css'

function Speakers({ seomatic, bizzaboSpeakers, craftCmsProfiles }) {

	// seo

	let metaTitle = JSON.parse(seomatic.metaTitleContainer)
    let metaTags = JSON.parse(seomatic.metaTagContainer) 

	// speakers

	// console.log('bizzabo speaker data:', bizzaboSpeakers)
	// console.log('bizzabo speakers found:', bizzaboSpeakers.length)
	// console.log('cms profile data:', craftCmsProfiles)

	let orderedSpeakers = _.orderBy( bizzaboSpeakers, ['lastname'], ['asc'])
	// console.log('ordered speaker data:', orderedSpeakers)

	return (
		<>

			<Head>
                <title>{metaTitle.title.title}</title>

                <meta name="description" content={metaTags.description.content} />
                <meta name="referrer" content={metaTags.referrer.content} />
                {/* <meta name="robots" content={metaTags.robots.content} /> */}
                <meta content={metaTags['og:locale'].content} property="og:locale" />
                <meta content={metaTags['og:site_name'].content} property="og:site_name" />
                <meta content={metaTags['og:type'].content} property="og:type" />
                <meta content={metaTags['og:url'].content} property="og:url" />
                <meta content={metaTags['og:title'].content} property="og:title" />
                <meta content={metaTags['og:description'].content} property="og:description" />
                <meta content={metaTags['og:image'].content} property="og:image"></meta>  
            </Head>

			<HeaderShim />

			<section className="block">
				<div className="container">

				<Sidebar size='medium' flipped>

					<main>

						{/* bizzabo speakers */}

						<p className='fs-1 fw-600 lh-1 c-black maxw-40'>2023 SPEAKERS</p>
						
						<SpeakerGrid decal="gap-sm mt-md">
							{orderedSpeakers.map( speaker => {
								if ( !speaker.hidden ) return (
									<div key={speaker.id}>
										<Link href={`/speakers/${speaker.id}`}>
											<a className={CSS.avatar}>
												{
													speaker.photoSet ? 
													<Image 
														src={speaker.photoSet.large} 
														width={370} 
														height={370} 
														alt=""
													/>
													: 
													<Image 
														src='/assets/ui/avatar-fallback.png' 
														width={370} 
														height={370} 
														alt=""
													/>
												}
											</a>
										</Link>
										<div>
											<p className='mt-xs'><span className='fw-600 fs-6 c-black'>{speaker.firstname} {speaker.lastname}</span> <br/>{speaker.title} <br/>{speaker.company}</p>
										</div>
									</div>
								)
							})}
						</SpeakerGrid>

					</main>

					<aside>
						<div>
							<p className='fs-3 fw-600 c-black lh-2'>STAY IN THE LOOP ABOUT SPEAKERS FOR IDEEA 2023.</p>
							<p className='maxw-60 my-sm'>If you haven&apos;t shared your details to stay updated about IDEEA, share your name and email, and we will keep you updated. </p>
						</div>

						<HubspotForm portalId={'14527187'} formId={'89a9b00a-16a4-4fc9-a1c6-c775ff52c69d'} />
					</aside>

				</Sidebar>
					

				</div>
			</section>

		</>
	)
}

export async function getStaticProps() {

	const bizzaboSpeakers = await fetch(`https://api.bizzabo.com/api/speakers?eventId=${process.env.BIZZABO_EVENT_ID}&size=200`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const json = await bizzaboSpeakers.json()


	const cmsData = await craftApolloClient().query({
        query: gql`
			query SEO {
				entry(site: "${process.env.SITE_HANDLE}", id: "22417") {
					title
					seomatic (asArray: true) {
						metaTitleContainer
						metaTagContainer
					}
				}
			}
        `
    })


	return {
		props: { 
			bizzaboSpeakers: json.content,
			seomatic: cmsData.data.entry.seomatic,
		}
	}
}

export default Speakers


